import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import * as apis from '@/apis/catalogue';
import * as actions from '@/actions';
import { hasBomEquipment, getPayload } from '@/helpers/catalogue';
import {
  IgetEquipmentDetails,
  IfetchServiceNumbers,
  IgetPricePlanAssociation,
  DevicePlanGroupRequest
} from '@/actions/catalogue/models/types';
import { getMatchSIMonly, getMobileShare } from '@/helpers/common';
import { RRP_EQUIPMENT, NEWLINE, MOBILE_SHARE, SER_ROADSHOW, TRANSFER_MOBILE_LINE, RECONTRACT, CHANGE_PLAN } from '@/config/common';
import {
  PRICE_PLAN_GROUP_REQUEST,
  PRICE_PLAN_ASSOCIATION_REQUEST,
  ADDON_GROUP_REQUEST,
  EQUIPMENT_DETAILS_REQUEST,
  SERVICE_NUMBER_REQUEST,
  DEVICE_BRANDS_REQUEST,
  GET_MOBILE_SHARE_REQUEST,
  GET_MOBILE_SHARE_ELIGIBILITY_REQUEST,
  GET_DEVICES_BY_PLAN_GROUP_REQUEST,
  GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST,
  GET_SMART_TEMPLATE_MENU_REQUEST,
  UPDATE_SMART_TEMPLATE_NAME_REQUEST,
  DELETE_SMART_TEMPLATE_REQUEST,
  GET_CHECK_RESERVE_REQUEST,
  GET_RESERVED_STOCKS_REQUEST,
  GET_SMART_TEMPLATE_BY_ID_REQUEST,
  GET_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST,
  GET_DEP_RESELLER_ID_REQUEST
} from '@/actions/catalogue/actionTypes';

export const getAuth = (state) => state.auth;
export const getOrder = (state) => state.order.currentOrder;
export const getTransferLine = (state) => state.transferLine;
export const getCatalogue = (state) => state.catalogue;


function* getPricePlanGroup(reqData) {
  try {
    const cartType = reqData.shoppingCartType;
    const shoppingCartType = ([RECONTRACT, CHANGE_PLAN, SER_ROADSHOW].includes(cartType)) ? cartType : NEWLINE;
    const auth = yield select(getAuth);
    const {
      currentAccount: { msaheaderId, brn }
    } = auth;
    const { cartDetails } = yield select(getOrder);
    const productCodeList = ([RECONTRACT, CHANGE_PLAN].includes(cartType) && cartDetails && cartDetails.serviceNumbers) ? cartDetails.serviceNumbers.map(items => items.productCode) : [];
    const productFamilyList = ([RECONTRACT, CHANGE_PLAN].includes(cartType) && cartDetails && cartDetails.serviceNumbers) ? cartDetails.serviceNumbers.map(items => items.productFamily) : [];
    // const productCodeList = [];
    const reqBRN = cartType === TRANSFER_MOBILE_LINE ? reqData.transfereeOfBrn : brn;
    const result = yield call(apis.getPricePlanGroup, {
      msaHeaderId: msaheaderId,
      brn: reqBRN,
      transactionType: shoppingCartType,
      productCodeAndFamilyDto: {
        existingPricePlanProductCode: productCodeList,
        existingPricePlanProductFamily: productFamilyList
      }
    });
    let finalResult = result.data;
    // if shoppingcartType is Newline or mobileShare, mobileShare details will be appended
    if ([NEWLINE, MOBILE_SHARE].includes(cartType) && !auth.isStaffLogin) {
      const mobileShareObj = {
        groupId: 'MobileShare Supplementary Plan',
        groupName: 'MobileShare Supplementary Plan',
        errors: [null],
        pricePlans: [{}],
        subscribersDesc: '',
        displayName: '',
        ranking: 7,
        groupDesc: '',
        termsAndConditions: ''
      };

      const resultPart = yield call(apis.getPlanByType, {
        msaHeaderId: msaheaderId,
        planType: 'Mobileshare'
      });

      mobileShareObj.pricePlans = resultPart.data;
      finalResult.push(mobileShareObj);
    }
    yield put(actions.getPricePlanGroup.success(finalResult));
  } catch (error) {
    yield put(actions.getPricePlanGroup.failure(error));
  }
}

function* getMobileShareLines() {
  try {
    const result = yield call(apis.getMobileShareLines);
    yield put(actions.getMobileShareLines.success(result.data));
  } catch (error) {
    yield put(actions.getMobileShareLines.failure(error));
  }
}

function* getMobileShareEligibility(requestData) {
  try {
    const result = yield call(apis.getMobileShareEligibility, requestData.requestData);
    yield put(actions.getMobileShareEligibility.success(result.data));
  } catch (error) {
    yield put(actions.getMobileShareEligibility.failure(error));
  }
}

function* getPricePlanAssociation({ requestData }: IgetPricePlanAssociation) {
  try {
    const auth = yield select(getAuth);
    const order = yield select(getOrder);
    const payload = getPayload(auth, order, requestData);
    if ([NEWLINE, MOBILE_SHARE].includes(payload.transactionType) &&
      getMobileShare(order.cartDetails.pricePlan?.pricePlanGroupId, order.cartDetails.pricePlan)
    ) {
      payload.transactionType = RRP_EQUIPMENT;
    }
    if ([TRANSFER_MOBILE_LINE].includes(payload.transactionType)) {
      const transferLine = yield select(getTransferLine);
      const { pricePlanGroup } = yield select(getCatalogue);
      const mobilePlan = transferLine.transferlineDetail.tlFormDetails.find((ele) => ele.fieldKey === "mobilePlan")
      let planDetails: any = {}
      pricePlanGroup.forEach((group) => {
        group.pricePlans.forEach((plan) => {
          if (plan.planName === mobilePlan.fieldValue) {
            planDetails = plan
          }
        })
      })
      // const newBrn = transferLine.transferlineDetail.tlFormDetails.find((ele) => ele.fieldKey === "mobilePlan")
      payload.transactionType = NEWLINE;
      payload.planId = planDetails.planId
    }

    const result = yield call(apis.getPricePlanAssociation, payload);
    if (order.cartDetails.pricePlan && getMatchSIMonly(order.cartDetails.pricePlan?.pricePlanGroupId)) {
      const trans_type = { transactionType: RRP_EQUIPMENT };
      const payload_rrp = { ...payload, ...trans_type };
      const result_rrp = yield call(apis.getPricePlanAssociation, payload_rrp);
      result.data.accessories = result_rrp.data.accessories;
      result.data.equipments = result_rrp.data.equipments;
      yield put(actions.getPricePlanAssociation.success(result.data));
    } else {
      yield put(actions.getPricePlanAssociation.success(result.data));
    }
  } catch (error) {
    yield put(actions.getPricePlanAssociation.failure(error));
  }
}

function* getAddonGroup(data) {
  try {
    const auth = yield select(getAuth);
    const {
      currentAccount: { msaheaderId, brn },
      userInfo: { email }
    } = auth;
    const transactionType = data.reqData.transactionType;
    const order = yield select(getOrder);
    const hasBom = hasBomEquipment(order);
    const pricePlanId = order.cartDetails?.pricePlan?.pricePlanId;
    const result = yield call(apis.getAddonGroup, msaheaderId, brn, transactionType, email, hasBom, pricePlanId);
    yield put(actions.getAddonGroup.success(result.data?.addOnGroups));
  } catch (error) {
    yield put(actions.getAddonGroup.failure(error));
  }
}

function* getEquipmentDetails({
  deviceType,
  modelCode,
  brandDescription,
  earlyRecontractDetails
}: IgetEquipmentDetails) {
  try {
    const auth = yield select(getAuth);
    const order = yield select(getOrder);
    const payload = getPayload(auth, order, {
      deviceType,
      modelCode,
      brandDescription,
      earlyRecontractDetails
    });
    //const result = yield call(apis.getEquipmentDetails, payload);
    //yield put(actions.getEquipmentDetails.success({ variants: result.data, modelCode }, {}, {}));
    if ([NEWLINE, MOBILE_SHARE].includes(payload.transactionType) &&
      getMobileShare(order.cartDetails.pricePlan?.pricePlanGroupId, order.cartDetails.pricePlan)
    ) {
      payload.transactionType = RRP_EQUIPMENT;
    }
    if (order.cartDetails.pricePlan && getMatchSIMonly(order.cartDetails.pricePlan?.pricePlanGroupId)) {
      const trans_type = { transactionType: RRP_EQUIPMENT };
      const payload_rrp = { ...payload, ...trans_type };
      const result = yield call(apis.getEquipmentDetails, payload_rrp);
      yield put(actions.getEquipmentDetails.success({ variants: result.data, modelCode }, {}, {}));
    } else {
      const result = yield call(apis.getEquipmentDetails, payload);
      yield put(actions.getEquipmentDetails.success({ variants: result.data, modelCode }, {}, {}));
    }
  } catch (error) {
    yield put(actions.getEquipmentDetails.failure(error));
  }
}

function* fetchServiceNumber({ requestData }: IfetchServiceNumbers) {
  const auth = yield select(getAuth);
  try {
    const result = yield call(apis.getServiceNumber, {
      ...requestData,
      reservedBy: auth.userInfo.email
    });
    const numberList = (result.data?.svcNoList || []).map((item) => ({
      number: item.svcNo,
      name: '',
      email: '',
      status: item.status
    }));
    const totalPages = Math.ceil(result.data.numberOfRecords / requestData.pageSize);
    yield put(
      actions.getServiceNumber.success(numberList, {
        totalRecords: result.data.numberOfRecords,
        totalPages,
        currentPage: requestData.currentPage
      })
    );
  } catch (error) {
    yield put(actions.getServiceNumber.failure(error));
  }
}

function* getDeviceBrand() {
  try {
    const result = yield call(apis.getDeviceBrands);
    yield put(actions.getDeviceBrands.success(result.data));
  } catch (error) {
    yield put(actions.getDeviceBrands.failure(error));
  }
}

function* getDeviceByPlanGroup({ page, size, reqData }: DevicePlanGroupRequest) {
  try {
    const result = yield call(apis.getDeviceByPlanGroup, page, size, reqData);
    yield put(actions.getDeviceByPlanGroup.success(result.data));
  } catch (error) {
    yield put(actions.getDeviceByPlanGroup.failure(error));
  }
}

function* getSmartTemplateListDetails(reqData) {
  try {
    const result = yield call(apis.getSmartTemplateListDetails, reqData.reqData);
    yield put(actions.getSmartTemplateListDetails.success(result.data));
  } catch (error) {
    yield put(actions.getSmartTemplateListDetails.failure(error));
  }
}

function* getSmartTemplates() {
  try {
    const payload = {
      page: 1,
      size: 20
    }
    const result = yield call(apis.getSmartTemplateListDetails, payload);
    if (result.data.smartTemplateConfigDtoList) {
      const templateList = result.data.smartTemplateConfigDtoList.map((template) => {
        return {
          templateId: template.templateId,
          templateName: template.name,
          category: template.category
        }
      })
      yield put(actions.getSmartTemplates.success(templateList));
    }
  } catch (error) {
    yield put(actions.getSmartTemplates.failure(error));
  }
}

function* updateSmartTemplateName(reqData) {
  try {
    const payload = {
      page: 1,
      size: 10
    }
    const result = yield call(apis.editSmartTemplateName, reqData.reqData);
    yield put(actions.updateSmartTemplateName.success(result.data));
    yield put(actions.getSmartTemplateListDetails.request(payload));
  } catch (error) {
    yield put(actions.updateSmartTemplateName.failure(error));
  }
}

function* deleteSmartTemplate(reqData) {
  try {
    const payload = {
      page: 1,
      size: 10
    }
    const result = yield call(apis.deleteSmartTemplate, reqData.templateId);
    yield put(actions.deleteSmartTemplate.success(result.data));
    yield put(actions.getSmartTemplateListDetails.request(payload));
  } catch (error) {
    yield put(actions.deleteSmartTemplate.failure(error));
  }
}


function* getSmartTemplateById(reqData) {
  try {
    const templateDetails = yield call(apis.getSmartTemplateById, reqData.templateId);
    yield put(actions.getSmartTemplateById.success(templateDetails.data));
  } catch (error) {
    yield put(actions.getSmartTemplateById.failure(error));
  }
}


function* getStockCheckReserve() {
  try {
    const result = yield call(apis.getDeviceCheckReserve);
    if (result.data.success) {
      yield put(actions.getCheckReserve.success(result.data));
    } else {
      const error = {
        response: {
          data: {
            message: 'Unsuccessful'
          }
        }
      };
      yield put(actions.getCheckReserve.failure(error));
    }
  } catch (error) {
    yield put(actions.getCheckReserve.failure(error));
  }
}

function* getReservedStocksByModel(reqData) {
  try {
    const payload = reqData.reqData;
    const result = yield call(apis.getReservedStocksVariant, payload);
    let stockData = [];
    if (result.data.length > 0) {
      stockData = result.data[0]?.deviceStockDtos || []
    }
    yield put(actions.getReservedStocksByModel.success(stockData));
  } catch (error) {
    yield put(actions.getReservedStocksByModel.failure(error));
  }
}

function* getBillAccListNumberPool(payload) {
  try {
    const result = yield call(apis.getNumberPoolBillingAccounts, payload);
    yield put(actions.getBillingAccForNumberPool.success(result.data));
  } catch (error) {
    yield put(actions.getBillingAccForNumberPool.failure(error));
  }
}

function* getCheckoutBillAccNumberPool(payload) {
  try {
    const result = yield call(apis.getNumberPoolSelectedBillAcc, payload);
    yield put(actions.getCheckoutBillAccNumberPool.success(result.data));
  } catch (error) {
    yield put(actions.getCheckoutBillAccNumberPool.failure(error));
  }
}

function* getBundledAddonsForPriceplan(data) {
  try {
    const auth = yield select(getAuth);
    const {
      currentAccount: { msaheaderId },
    } = auth;
    const result = yield call(apis.getBundledAddonsForPriceplan, msaheaderId, data.data);
    yield put(actions.getBundledAddonsForPriceplan.success(result.data));
  } catch (error) {
    yield put(actions.getBundledAddonsForPriceplan.failure(error));
  }
}

function* getDepResellerBrn() {
  try {
    const result = yield call(apis.getDepResellerBrnIds);
    console.log(result);
    yield put(actions.getDepResellerBrn.success(result.data));
  } catch (error) {
    yield put(actions.getDepResellerBrn.failure(error));
  }
}
export default function* catalogueSagas() {
  yield takeLatest(PRICE_PLAN_GROUP_REQUEST, getPricePlanGroup);
  yield takeLatest(GET_MOBILE_SHARE_REQUEST, getMobileShareLines);
  yield takeLatest(GET_MOBILE_SHARE_ELIGIBILITY_REQUEST, getMobileShareEligibility);
  yield takeLatest(PRICE_PLAN_ASSOCIATION_REQUEST, getPricePlanAssociation);
  yield takeLatest(ADDON_GROUP_REQUEST, getAddonGroup);
  yield takeLatest(EQUIPMENT_DETAILS_REQUEST, getEquipmentDetails);
  yield takeLatest(SERVICE_NUMBER_REQUEST, fetchServiceNumber);
  yield takeLatest(DEVICE_BRANDS_REQUEST, getDeviceBrand);
  yield takeLatest(GET_DEVICES_BY_PLAN_GROUP_REQUEST, getDeviceByPlanGroup);
  yield takeLatest(GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST, getSmartTemplateListDetails);
  yield takeLatest(GET_SMART_TEMPLATE_MENU_REQUEST, getSmartTemplates);
  yield takeEvery(UPDATE_SMART_TEMPLATE_NAME_REQUEST, updateSmartTemplateName);
  yield takeLatest(DELETE_SMART_TEMPLATE_REQUEST, deleteSmartTemplate);
  yield takeLatest(GET_SMART_TEMPLATE_BY_ID_REQUEST, getSmartTemplateById);
  yield takeLatest(GET_CHECK_RESERVE_REQUEST, getStockCheckReserve);
  yield takeLatest(GET_RESERVED_STOCKS_REQUEST, getReservedStocksByModel);
  yield takeLatest(GET_NUMBER_POOL_BILL_ACC_REQUEST, getBillAccListNumberPool);
  yield takeLatest(GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST, getCheckoutBillAccNumberPool);
  yield takeLatest(GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST, getBundledAddonsForPriceplan);
  yield takeLatest(GET_DEP_RESELLER_ID_REQUEST, getDepResellerBrn);
}